import { Controller } from "@hotwired/stimulus"

// Schickt das Ziel-Formular ab, z.B. beim Aufklappen eines Accordion-Items (show.bs.collapse).
export default class extends Controller {
  static targets = ["form"]

  submit() {
    if (this.hasFormTarget) this.formTarget.requestSubmit()
  }
}
